import { AxiosRequestConfig } from 'axios';
import { IUser } from '@src/models/UserStore';
import { IImjSettings } from '@src/features/candidates/features/settings/organisms/NotificationSettings';
import request, { SuccessResponse } from 'src/services/request';

export const getUserInfo = (config?: AxiosRequestConfig) => request.get<void, IUser>('/users/me', config);
export const updateUser = (payload: { user: IUser }) => request.put<void, IUser>('/users/me', payload);

export const deleteUser = () => request.delete<void, IUser>('/users/me');

export const updatePhoto = (payload: FormData) =>
  request.put<void, SuccessResponse<{ photo_url: string }>>('/users/me/photo', payload);

export const updateCV = (payload: FormData) =>
  request.put<void, SuccessResponse<{ photo_url: string }>>('/users/me/resume', payload);

// Settings
export const getSettings = (config?: AxiosRequestConfig) =>
  request.get<void, { follow_ups: boolean; newsletters: boolean }>('/users/me/settings', config);

export const updateSettings = (payload: {
  email_notifications?: { follow_ups: boolean; newsletters: boolean };
  password?: string;
  password_confirmation?: string;
  mailjet_lists?: IImjSettings;
}) => request.put('/users/me/settings', payload);

// Preferences
export const getFavoriteRoles = (config?: AxiosRequestConfig) => request.get('/users/me/preferences', config);
export const createFavoriteRole = payload => request.post(`/users/me/preferences`, payload);
export const updateFavoriteRole = payload => request.put(`/users/me/preferences/${payload.id}`, payload);
export const deleteFavoriteRole = (favoriteRoleId: number) => request.delete(`/users/me/preferences/${favoriteRoleId}`);

export const getUserVisas = (config?: AxiosRequestConfig) => request.get('/users/me/visas', config);
export const getUserWorkPlaces = (config?: AxiosRequestConfig) => request.get('/users/me/work_places', config);
export const updateUserWorkplaces = payload => request.patch('/users/me/work_places', payload);
export const deleteUserWorkplace = ({ workPlaceId }) => request.delete(`/users/me/work_places/${workPlaceId}`);

export const acceptInvitation = (invitationId: number, payload: { accept?: boolean }) =>
  request.put(`/users/me/invitations/${invitationId}/accept`, payload);

export const getApplications = (config?: AxiosRequestConfig) => request.get('/users/me/applications', config);
export const getCandidateRoles = qs => '/users/me/suggestions/jobs' + qs;

export const withdrawApplication = (payload: { application_id: number; rating?: number; feedback?: string } | { interest_id: number }) =>
  request.put(`/users/me/applications/withdraw`, payload);

export const updateStepFeedback = (applicationId: number, payload: { step_id: number; rating: number; feedback?: string, continue_application: boolean }) =>
  request.post(`/users/me/applications/${applicationId}/feedback`, payload);
